import React from 'react';
import styles from '../css/search.module.css'

function SearchTrip({ query, setQuery, handleFocus, activeTab }) {

  const label = activeTab === 'trips' ? 'Szukaj przejazdu' : 'Szukaj wyjśćia na szlak'
  const placeholder = activeTab === 'trips' ? "nazwa miejscowości... " : "np. Rysy, Babia Góra, Giewont "

  return (
      <div className={`${styles.sectionSearchTrip} userSelectNone` }>

        <p className='userSelectNone'>{label}</p>
        <input
          className={styles.searchTripsInput}
          type="text"
          placeholder= {placeholder} 
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={handleFocus}
        />
      
      </div>
  );
}

export default SearchTrip;
